import { mapState } from 'vuex';

import symptoms from '@/components/api/recognizesymptoms/symptoms/index.vue'
import symptomsmap from '@/components/api/recognizesymptoms/symptomsmap/index.vue'
import diseases from '@/components/api/recognizesymptoms/diseases/index.vue'


var nl2br  = require('nl2br');

export default {
    name: 'recognizesymptoms',
    components : {
        symptoms,
        diseases,
        symptomsmap
    },
    props: {
    },

    data : function(){


        return {    
            stikyKit: {
                recalc_every: 1,
                options: {
                    parent: '.sp',
                    offset_top: 50
                },
                on: {
                    'sticky_kit:stick': function(e) {
                    },
                    'sticky_kit:unstick': function(e) {
                    },
                }
            },
            plaintext : `hx of multiple suicide attempts
            osteoarthritis of knee joints
            left knee arthroscopy, 1995
            partial hysterectomy, 1990
            nicotine dependence, 30 years
            Medications
            Cymbalta 60 mg po qday
            Fluticasone furoate nasal spray 27.5 mcg prn
            albuterol inhalation aerosol 17 g prn
            omacor 900 mg QID
            mesalamine(pentasa) 500 mg QID
            Ambien CR 12.5 mg qhs prn
            fluticasone/salmeterol (Advair diskus) 250/50 prn
            Protononix 40 mg qday
            palidperidone (invega) 3 mg qday
            sitalgliptin/metformin (Junamet) 50/500 mg qday
            gabapentin 400 mg TID
            conjugated g-estrogens (premarin) .625 mg qday
            lisinopril 5 mg qday
            mecaptopurine 50 mg BID
            nexium 40 mg qday
            clonazepam 1.5 mg BID
            Allergies
            Penicillin, causes rash and anaphylaxis
            morphine, causes itching
            IV Contrast, causes tachycardia
            3
            Social History
            Ms. ___ lives in _________ with her husband. She has 6 children who are in good health but do
            not live with her. Ms. ___ is on disability for her bipolar diagnosis and usually spends her days at
            home and caring for a sick older relative. She smokes half a ppd and has done so for the past 30
            years. She states that she does not use any other drugs and that she does not consume alcohol.
            She has been involved in the distribution of crack cocaine for years in the past but stopped two
            years ago. While her husband is a crack user, she states that she has never been a user of any
            illicit drugs or narcotics. She is not physically active and her diet consists of small food portions
            but is generally unhealthy. She suffers from chronic abdominal pain secondary to her Crohn’s,
            and also chronic right knee and lower back pain from a fall injury and osteoarthritis. She uses a
            cane when her knee and back pain become debilitating. She has a history of narcotic-seeking
            behavior and has left during past hospital visits when narcotic medications would not be
            prescribed for her pain. She no longer receives narcotics from UNC after breaking her pain
            contract with her family medicine provider but it is unclear if she receives pain medications from
            an outside hospital. She has been incarcerated in the past for arson and attempted murder.
            Family History
            Mother - bipolar and Schizophrenia, "drank herself to death"
            Father - living with diabetes, s/p CABG.
            2 sisters with HTN
            Maternal grandfather, leukemia
            Review of Systems
            Constitutional: denies anorexia and weight loss
            HEENT: denies decreased hearing blurring, diplopia, irritation, discharge, vision loss, eye pain,
            photophobia, ear pain or discharge, tinnitus, nasal obstruction or discharge, nosebleeds, sore
            throat, hoarseness, dysphagia
            Cardiovascular: dyspnea on exertion; denies chest pains, palpitations, syncope, orthopnea, PND,
            edema
            Respiratory: denies cough and wheezing
            Gastrointestinal: denies jaundice
            Genitourinary: denies incontinence, dysuria, hematuria, urinary frequency
            Musculoskeletal: arthritis in left knee and pain in lower back pain from past injury; denies other
            4
            joint pain, joint swelling, muscle cramps, muscle weakness, stiffness,
            Skin: denies rash, dryness, suspicious lesions
            Neurologic: chronic weakness in her left knee; denies transient paralysis, paresthesias, seizures,
            syncope, tremors, vertigo
            Psychiatric: denies depression, anxiety, memory loss, mental disturbance, suicidal ideation,
            hallucinations, paranoia
            Endocrine: denies cold intolerance, heat intolerance, polydipsia, polyphagia, polyuria
            Heme/lymphatic: denies bruising, bleeding, enlarged lymph nodes
            Allergic/Immunologic: denies urticaria, hay fever, persistent infections, HIV exposure
            Physical Examination
            Vitals from ED admission
            Temperature : 36.3
            Pulse : 79
            Respiratory Rate : 16
            Blood Pressure : 116/82
            Oxygen Saturation%: 97% on RA
            Pain Score : 10/10
            General
            Obese, sleepy but oriented woman lying in bed
            Eyes
            Conjunctivae and lids normal, pupils equal, round, reactive to light and, accommodation, discs
            sharp and flat, no a/v nicking, hemorrhages, or exudates, normal visual acuity, EOM intact.
            ENNT`,
            classification : 'UMLS',
            classifications : [
                {
                    name : 'UMLS',
                    id : 'UMLS'
                },
                {
                    name : 'MEDCIN',
                    id : 'MEDCIN'
                },
                {
                    name : 'Medical Subject Headings (MeSH)',
                    id : 'MSH'
                },
                {
                    name : 'Current Procedural Terminology',
                    id : 'CPT'
                },
                {
                    name : 'Logical Observation Identifiers Names and Codes terminology (LOINC)',
                    id : 'LNC'
                },
                {
                    name : 'National Cancer Institute (NCI)',
                    id : 'NCI'
                },
                {
                    name : 'Read Codes',
                    id : 'RCD'
                },
                {
                    name : 'ICD-10',
                    id : 'ICD10'
                },
                {
                    name : 'RxNorm',
                    id : 'RXNORM'
                },
                {
                    name : 'Metathesaurus Names (MTH)',
                    id : 'MTH'
                },
                {
                    name : 'Online Mendelian Inheritance in Man (OMIM)',
                    id : 'OMIM'
                },

                {
                    name : 'SNOMED CT US Edition',
                    id : 'SNOMEDCT_US'
                },

                	
            ],
            symptoms : null,
            details : null,
            loading : false,
            diseases : null,

            legend : [

                {

                }

            ],

            selectedConcept : null,
            selectedConceptNum : 0
        }

    },

    created : function(){
        this.$root.api.apikey('IQft1F1f1OfmJA7_hwhYzokS959ZyylR')

        
    },

    

    beforeRouteEnter (to, from, next) {
        next()
    },

    beforeRouteUpdate (to, from, next) {
        next()
    },

    computed: mapState({
        auth : state => state.auth,
        symptomsLength : function(){
            return _.toArray(this.symptoms)
        },
        showmap : function(){
            return true;
            console.log('this.symptoms', this.symptoms)
           
            
            var m = 0;
            
            _.each(this.symptoms, (s) => {

                var count = 0;

                _.each(this.details, function(d){
                    _.each(d.concepts, function(sc){
                        if(sc == s.CUI) count++
                    })
                })

                console.log('count', count)

                if(count > m) m = count

            })

            console.log('result', m)

            return 1 < m
        },


        sentensesWithConcept : function(){
            return _.filter(this.details, (tobj) => {
                return _.find(tobj.concepts, (c) => {
                    return c.CUI == this.selectedConcept
                })
            })
            
        },

        
    }),

    watch : {
        symptoms : function(){
            this.getdiseases()

        }
    },

    methods : {
        changePlaintext : function(evt){
            this.plaintext = evt.target.value
        },
        changeClassification : function(evt){
            this.classification = evt.target.value

            this.getsymptoms()
        },

        getdiseases : function(){


            var s = _.filter(this.symptoms, function(s){
                if(!s.negated) return true
            })
            var codes = _.map(s, function(s){
                return s.CUI
            })

            this.loading = true

            return this.$root.api.request.diseasesBySymptoms({

                codes : JSON.stringify(codes),
                coeffvec : true,
                clusterize : true,
                code : this.classification

            }).then(diseases => {

                console.log('diseases', diseases)

                this.loading = false

                this.diseases = diseases.data

            }).catch(e => {

                this.$store.commit('icon', {
                    icon : 'error',
                    message : "Something went wrong"
                })

                this.loading = false
                
            })
        },

        getsymptoms : function(){

            if(!this.plaintext.length) return

            this.diseases = null
            this.loading = true
            this.selectedConcept = null
            this.selectedConceptNum = 0

            this.$root.api.request.conceptsRecognition({
        
                text : this.plaintext,
                code : this.classification

            }).then(results => {

                this.loading = false

                this.symptoms = results?.data?.concepts || {}
                this.details = results?.data?.details || []

            }).catch(e => {

                this.$store.commit('icon', {
                    icon : 'error',
                    message : "Something went wrong"
                })

                this.loading = false
                
            })
        },

        lightSentense : function(tobj){
            return _.find(tobj.concepts, (c) => {
                return c.CUI == this.selectedConcept
            })
        },

        selectedSentenseWithConcept : function(tobj){
            var f = _.filter(this.details, (tobj) => {
                return _.find(tobj.concepts, (c) => {
                    return c.CUI == this.selectedConcept
                })
            })


            if (f.length){
                return f[this.selectedConceptNum].text == tobj.text
            }

            
        },

        lcnnum : function(){
            this.selectedConceptNum--

            if (this.selectedConceptNum < 0){
                this.selectedConceptNum = this.sentensesWithConcept.length - 1
            }

            this.scrollToSelected()
        },

        rcnnum : function(){
            this.selectedConceptNum++

            if (this.selectedConceptNum > this.sentensesWithConcept.length - 1){
                this.selectedConceptNum = 0
            }

            this.scrollToSelected()
        },

        clearMap : function(){
            this.selectedConcept = null
            this.selectedConceptNum = 0
        },

        selectConcept : function(cui){

            console.log('cuicui', cui)

            this.selectedConcept = cui
            this.selectedConceptNum = 0

            this.scrollToSelected()
        },

        scrollToSelected : function(){
            setTimeout(function(){

                let elmnt = document.querySelector(".txt[selected='selected'][selectedSentenseWithConcept='true']");

            
                elmnt.scrollIntoView(true);
                window.scrollBy(0, -90)

            }, 100)
        },

        nl2br : function(t){
            return nl2br(t)
        },

        expltext : function(){
            return _.reduce(this.details, function(m, d){
                return m + nl2br(d.text)
            }, '')
        }
    },
}